import { useGenomeViewerStore } from "../../../store/store.ts";
import { SVG_STYLES } from "../settings.ts";

export function useAnchorPosition(groupId: string, scale: number) {
  const alignedTrackGroupStarts = useGenomeViewerStore((state) => state.alignedTrackGroupStarts);
  const basePerPixel = useGenomeViewerStore((state) => state.basePerPixel);
  const start = alignedTrackGroupStarts?.get(groupId);

  if (start == undefined) {
    return undefined;
  }

  return (start / basePerPixel) * scale - SVG_STYLES.anchorPoint.width / 2;
}
